/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEffectiveBasicCostRequest } from '../../models/create-effective-basic-cost-request';

export interface CreateEffectiveBasicCost$Params {
      body: CreateEffectiveBasicCostRequest
}

export function createEffectiveBasicCost(http: HttpClient, rootUrl: string, params: CreateEffectiveBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, createEffectiveBasicCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

createEffectiveBasicCost.PATH = '/v0/effectiveBasicCost';
